import React, { useState } from 'react';
import { SearchInput } from '@kaleyra/emmy';
import i18n from 'i18next';
import Styles from './index.module.scss';

type HeaderBodyTemplatePropsType = {
	title?: string;
	leftNode?: React.ReactNode;
	onChange: (searchTerm?: any) => void;
	placeholder?: string;
	// hatch to clear the searchbox
	currentTab?: string;
};

const HeaderBodyTemplate: React.FC<HeaderBodyTemplatePropsType> = ({
	children,
	title,
	onChange,
	leftNode,
	placeholder,
	currentTab,
}) => {
	const [searchVal, setSearchVal] = useState('');

	React.useEffect(() => {
		setSearchVal('');
	}, [currentTab]);

	return (
		<>
			<div className={Styles.titlebar}>
				<div>
					{title && <h4>{title}</h4>}
					{leftNode !== undefined && leftNode}
				</div>
				<div className={Styles.actionContainer}>
					<SearchInput 
						value={searchVal} 
						onChange={(val: any) => { onChange(val); setSearchVal(val) }} 
						eachChar 
						placeholder={placeholder||i18n.t("mainSearch")} 
						label={placeholder||i18n.t("mainSearch")} 
						{...(currentTab && { key: currentTab })} />
				</div>
			</div>
			<div className={Styles.tableContainer}>{children}</div>
		</>
	);
};

export default HeaderBodyTemplate;
